
import Vue from 'vue'
import App from './App.vue'
import router from './router'


import vuetify from './plugins/vuetify';

import i18n from './i18n'
import NotTranslated from '@/components/NotTranslated'
import Rhaboo from './rhaboo.min.js'
import './registerServiceWorker'
import store from './store'

// include Japanese UI since it's really small
import Japanese_UI from '@/uilang/ja'


let ls = Rhaboo.persistent("rhaboo");
if (!ls.search_history) ls.write('search_history', []);

Vue.prototype.$ls = ls;

let code = window.localStorage.getItem("language") || 'en';
store.commit('change_language', code);

//Vue.component('NotTranslated', NotTranslated);



Vue.config.productionTip = false;

Vue.filter('t', i18n.$t);


Vue.prototype.$t = i18n.$t;

Vue.prototype.$css = {
	naoword: 'main_color font-weight-medium',
	title: 'text-h4 text-md-h3 text-center pa-5'
};

let updates = [
	{ date: '2021-09-08', status: 'new', url: '/textbook',
	comment: 'Added 6 new lessons' },
	{ date: '2021-08-27', status: 'new', url: '/origins',
	comment: 'Article about the previous versions of Nao and the origin of elementary words' },
	{ date: '2021-06-24', status: 'new', 
	comment: 'Added the chatroom! Now visitors of the website can communicate with each other as well as with people from Discord and Telegram.' },
	{ date: '2021-05-24', status: 'new', url: '/transliterations/Greek',
	comment: 'Added transliteration for Greek' },
	{ date: '2021-05-08', status: 'new', url: '/comparison',
	comment: 'Created a page where Nao is compared with Esperanto, Lojban and Tokipona' },
	{ date: '2021-05-06', status: 'new', url: '/textbook',
	comment: 'Все имеющиеся уроки переведены на русский язык', language: 'ru' },
	{ date: '2021-03-14', status: 'new', url: '/textbook',
	comment: 'Added 11 new lessons' },
	{ date: '2021-02-25', status: 'new', url: 'https://nao.freeflarum.com/',
	comment: 'Created Nao language forum.' },
	{ date: '2021-02-11', status: 'new', url: '/elements',
	comment: 'Added the list of elementary words' },
	{ date: '2021-02-09', status: 'updated', url: '/transliterations/Japanese',
	comment: 'Added automatic transliteration for Japanese' },
	{ date: '2021-02-09', status: 'updated', url: '/transliterations/Mandarin',
	comment: 'Added automatic transliteration for Mandarin Chinese' },
	{ date: '2021-02-08', status: 'new', url: '/combinations',
	comment: 'Full list of all words in the dictionary.' },
	{ date: '2021-02-07', status: 'new', language: 'en',
	comment: 'It is now an app! By using the technology of PWA (Progressive Web Application), it can now work offline and you can even install it as an app on both mobile and desktop.'},
	{ date: '2021-02-05', url: '/textbook/colors', status: 'new', language: 'en',
	comment: 'Colors page was brought from the old website and now looks good on mobile.'},
];

let cmn = [
	{icon: 'Forum', url: 'https://nao.freeflarum.com/'},
	{icon: 'Discord', url: 'https://discord.gg/nBB6NqS', color: "#7289da"},
	{icon: 'Telegram', url: 'https://t.me/naolangbot', color: "#23aae8"},
	{icon: 'Reddit', url: 'https://www.reddit.com/r/naolanguage/', color: "#FF4500"},
	//{icon: 'facebook', url: 'https://www.facebook.com/naolanguage/', color: "#3b5998"},
];

Vue.prototype.$g = {
	NotTranslated,
	updates,
	cmn,
};

import { mdiArrowExpandRight, mdiArrowLeft, mdiArrowRight, mdiChat, mdiCheck, mdiChevronDown, mdiClose, mdiCog, mdiCommentQuote, mdiDiscord, mdiFileMultiple, mdiForum, mdiMagnify, mdiPatreon, mdiPlus, mdiReddit, mdiSchool, mdiSend, mdiStar, mdiTableSplitCell, mdiTelegram, mdiTranslate, mdiVolumeHigh } from '@mdi/js';

let mdi = { mdiArrowExpandRight, mdiArrowLeft, mdiArrowRight, mdiChat, mdiCheck, mdiChevronDown, mdiClose, mdiCog, mdiCommentQuote, mdiDiscord, mdiFileMultiple, mdiForum, mdiMagnify, mdiPatreon, mdiPlus, mdiReddit, mdiSchool, mdiSend, mdiStar, mdiTableSplitCell, mdiTelegram, mdiTranslate, mdiVolumeHigh };
 
Vue.prototype.$mdi = {};

for (let icon_name in mdi) {
	Vue.prototype.$mdi[icon_name.slice(3)] = mdi[icon_name];
	delete mdi[icon_name];
}

/*
import('@/nao').then(function(res){
	let Nao = res.default;
	window.Nao = Nao;
	Vue.prototype.$nao = Nao;
	Vue.filter('u', Nao.unmake_neutral);

	new Vue({
		router,
		store,
		vuetify,
		render: h => h(App)
	}).$mount('#app')

});

*/


import Nao from 'D:/tonebei/bot-nao/nao.js';

window.Nao = Nao;
Vue.prototype.$nao = Nao;
Vue.filter('u', Nao.unmake_neutral);

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')